var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-card"},[(this.$route.params.token)?_c('reset-password-card'):_c('reset-password-request-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }